<ada-card
	#CveMappingPropertiesCard
	id="CveMappingPropertiesCard"
	verticalSpacing="Small"
	width="100%"
	[collapseEnabled]="true"
>
	<ada-text
		content="CVE Mapping Properties"
		data-container-selector="ada-card-header"
		id="CveMappingPropertiesCardHeader"
	></ada-text>
	<ada-container
		data-container-selector="ada-card-body"
		horizontalSpacing="Medium"
		verticalSpacing="Medium"
		[colCount]="4"
		[padding]="defaultCardPadding"
	>
		<ng-container *ngIf="'CpeMatchStrings' | displayAuthoringProperty: editorClass: propertyConstructor.namespace">
			<ada-label
				content="Import From Match String"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			></ada-label>
			<ada-container
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-input
					data-testid="editor-import-cpe-string-input"
					placeholder="CPE Match String"
					[debounce]="100"
					[isDisabled]="isDisabled"
					[showAsFullWidth]="true"
					[(value)]="cpeStringToImport"
				></ada-input>
				<ada-push-button
					data-testid="import-cpe-string-button"
					icon="faPlus"
					look="Outline"
					size="Small"
					text="Import"
					[adaClick]="importCpeString | adaBindMethod : this"
					[isDisabled]="isDisabled"
				></ada-push-button>
			</ada-container>

			<ada-authoring-property-label
				#CpeMatchStringsLabel
				id="CpeMatchStringsLabel"
				content="CPE Match Strings"
				[inheriting]="currentPropertyObject?.CpeMatchStrings | inheritPipe:inheritedPropertyObject?.CpeMatchStrings"
				[isDisabled]="isDisabled"
				[isRequired]="'CpeMatchStrings' | isRequiredProperty: editorClass: propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteCpeMatchStrings()"
			></ada-authoring-property-label>
			<ada-container
				[colCount]="0"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-object-list-builder
					#CpeMatchStringsInput
					data-testid="editor-cpes-input"
					id="CpeMatchStringsInput"
					objectName="CPE Match String"
					[isDisabled]="isDisabled"
					[objectConfig]="cpesBuilderConfig"
					(customObjectsChange)="setCpeMatchStrings($event)"
				></ada-object-list-builder>
			</ada-container>
		</ng-container>
	</ada-container>
</ada-card>
